import React, {Component} from "react";
import {Link} from "react-router-dom";
import * as prosConnect from "../prodect/ProsConnect";
import {
    ATTR_AWS_PROJECT_ID,
    ATTR_OBJ_ID,
    ATTR_CREATED_MS_I,
    ATTR_UPDATED_MS_I,
    ATTR_PROJECT_LINK,
    ATTR_SELECTED_REPORTS,
    ATTR_UI_SEARCH,
    ATTR_UI_SETTINGS,
    ATTR_UI_VIEW_MODE,
    permissionToLinkAlreadyRequested,
    prosLog,
    prosLogX,
    prosLogClearDt,
    prosLogErr,
    ROLE_INSPECT,
    ROLE_READER,
    ROLE_REPAIR,
    setSuperUserMode,
    userHasAnsweredToGrantRequest,
    featureEnabled,
    FEAT_SHOW_TABLE,
    FEAT_SHOW_TIME_MATRIX,
    SAVED_MAIN_VIEW,
    SAVED_REPORT_VIEW,
    VIEW_MODE_LIST,
    VIEW_MODE_TABLE,
    VIEW_MODE_CALENDAR,
    VIEW_MODE_KANBAN,
    VIEW_MODE_DASHBOARD,
    VIEW_MODE_DEFAULT,
    ATTR_CUSTOMER_GROUP,
    restoreConfigStr,
    saveConfigStr,
    resetViewToDefault,
    currentTimeMs,
    ATTR_MAIN_PROJ_ID,
    getMainProject,
    SAVED_SELECTED_MAIN_PROJECT,
    isProjectDashboardLink,
} from "../prodect/ProsConnect";
import * as projectLoader from "../prodect/ProjectLoader";
import ProjectReports, {resetToNormalReportMode} from "./ProjectReports";
import CreateSubProject from "./CreateSubProject"
import CreateMainProject from "./CreateMainProject"
import Settings from "./Settings"
import CustomerSettings from "./CustomerSettings"
import {appProdectLogout, handleSessionException} from "../App";
import {
    prosNotificationShow,
    prosPopupClose,
    prosPopupOpen, prosPopupOpenDynamic, prosPopupSetHost,
    prosPopupRender
} from "../prodect/ProsPopup";
import {dumpTableFilter, restoreTableSettings, setTableSettings} from "./ProjectReportTable"
import {
    restoreMatrixUiSettings,
    saveMatrixSettings,
    saveMatrixSettingsKanban
} from "./ScheduleMatrix"
import {setSavedViewMode} from "./ProjectReports";
import HelpDesk from "./HelpDesk.js"
import {AcceptTerms} from "./AcceptTerms"
import * as HelpManager from "../prodect/HelpManager";
import SearchReportSettings from "./SearchReportSettings";
import LoadingAnimation from "../components/LoadingAnimation";
import PermissionManagement from "./PermissionManagement";
import {isSmallDevice, sideBarState, ProjectHeader} from "../prodect/ProsCommonUi";
import RadioButton from "../components/RadioButton";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import Spacer from "../components/Spacer";
import ProjectSettings from "./ProjectSettings";
import DropdownMenu from "../components/DropdownMenu";
import SharedReports from "./SharedReports";
import Bookmarks from "./Bookmarks";
import {prosAppNotifNotice, prosAppNotifWarn} from "../prodect/ProsAppNotif";
import NotificationRules from "./NotificationRules";
import {USE_DEVELOPMENT_FEATURES} from "../config";
import ProsSidebar from "../prodect/ProsSidebar";
import ProjectDashboard from "./project/ProjectDashboard";
import MainProjectSettings from "./MainProjectSettings";
import StartPage from "./StartPage";
import {projectViewChanged} from "../prodect/HelpManager";

/***********************************************************************************
 * Home view controls main state of the app but some of the views like project setup
 * will navigate out from it using reac router.
 * When app is started Home shows "loading..." until the following steps have been
 * completed - ref prosConnect awaitStartProdect() for a startup sequence.
 *
 * When startup have been completed "loading" status is cancelled to continue normal
 * rendering.  As Home may be launched multiple time this initial load procedure
 * is done only once after authentication so that an active project and user's active project
 * list are sotored in prosConnect which acts as a "local runtime DB"
 *
 * Home shows content based on this.state.mainProjectView - options MAIN_VIEW_ :
 *      MAIN_VIEW_SETTINGS                      - user and customer settings
 *      MAIN_VIEW_SUB_PROJECT_SETTINGS          - sub project settings
 *      MAIN_VIEW_NOTIFICATION_RULES          - notification rules
 *      MAIN_VIEW_CREATE_MAIN_PROJECT or
 *      MAIN_VIEW_EDIT_CUSTOMER                 - order project or edit project billing
 *      MAIN_VIEW_SEARCH_SETTINGS               - edit search settings / search criteria
 *      MAIN_VIEW_EDIT_PROJECT                  - edit project ( all subproject ) access rights

 ***********************************************************************************/

export const MAIN_VIEW_SETTINGS = "settingsView"
export const MAIN_VIEW_CUSTOMER_SETTINGS = "customerSettings"
export const MAIN_VIEW_SUB_PROJECT_SETTINGS = "projectSettings"
export const MAIN_VIEW_NOTIFICATION_RULES = "notificationRules"
export const MAIN_VIEW_REPORT = "reportView"
export const MAIN_VIEW_SEARCH_SETTINGS = "searchSettings"

export const MAIN_VIEW_CREATE_MAIN_PROJECT = "createNewMainProject"
export const MAIN_VIEW_EDIT_CUSTOMER = "editCustomer"
export const MAIN_VIEW_PROJECT_DASHBOARD = "projectDashboard"
export const MAIN_VIEW_MAIN_PRJ_SETTINGS = "mainProjectSettings"
export const MAIN_VIEW_EDIT_PROJECT = "editProjectAdmin"

export const MAIN_VIEW_CREATE_NEW_SUBPROJECT = "createNewSubProject"
export const MAIN_VIEW_BOOK_MARKS = 'projectBookmarks'
export const MAIN_VIEW_SENT_REPORTS = "sentReports"

export const MAIN_VIEW_STARTPAGE = "startPage"

const HIDE_SIDE_BAR_FOR_VIEWS = [MAIN_VIEW_SETTINGS, MAIN_VIEW_CUSTOMER_SETTINGS]
const HIDE_TOP_PANEL_FOR_VIEWS = [MAIN_VIEW_SETTINGS, MAIN_VIEW_CUSTOMER_SETTINGS, MAIN_VIEW_CREATE_MAIN_PROJECT, MAIN_VIEW_EDIT_CUSTOMER,
    MAIN_VIEW_EDIT_PROJECT, MAIN_VIEW_CREATE_NEW_SUBPROJECT, MAIN_VIEW_SEARCH_SETTINGS, MAIN_VIEW_STARTPAGE, MAIN_VIEW_PROJECT_DASHBOARD, MAIN_VIEW_MAIN_PRJ_SETTINGS]
const RELOAD_PROJECT_AFTER_VIEW = [MAIN_VIEW_SUB_PROJECT_SETTINGS]
const DO_NOT_SAVE_VIEW = [MAIN_VIEW_EDIT_CUSTOMER, MAIN_VIEW_EDIT_PROJECT, MAIN_VIEW_SEARCH_SETTINGS, MAIN_VIEW_NOTIFICATION_RULES]

let triedLogoutRecovery = 0;

const VIEW_MODES = {
    projectDashboard: {
        icon: 'gauge',
        text: 'Tilanne'
    },
    mainProjectSettings: {
        icon: 'gear',
        text: 'Asetukset'
    },
    dashboard: {
        icon: 'gauge',
        text: 'Tilanne'
    },
    list: {
        icon: 'list',
        text: 'Lista'
    },
    table: {
        icon: 'table',
        text: 'Taulukko'
    },
    matrix: {
        icon: 'calendar',
        text: 'Kalenteri'
    },
    kanban: {
        icon: 'kanban',
        text: 'Kanban'
    }
}

/**
 * Return last selected main view id - ref Home/MAIN_VIEW_*
 * If needed add check that user is authenticated and/or Home view is mounted
 */
export function gloGetMainView() {
    return restoreConfigStr(SAVED_MAIN_VIEW, MAIN_VIEW_STARTPAGE)
}

/**
 * When showing project report view return active report view id - ref prosConnect/VIE_MODE_*
 * Returns <undefined> when main view is not active (and thus none of the report views shown)
 */
export function gloGetReportView() {
    return gloGetMainView() === MAIN_VIEW_REPORT ?
        restoreConfigStr(SAVED_REPORT_VIEW, VIEW_MODE_DEFAULT) :
        undefined
}

/**
 * Used by project loader to know if need to start loading complete subproject
 * @returns {boolean}   true when need complete subproject, false when enough to load project main info
 */
export function viewNeedsCompleteProject() {
    let mainView = gloGetMainView()
    if ([MAIN_VIEW_SEARCH_SETTINGS, MAIN_VIEW_SENT_REPORTS].includes(mainView)) {
        return true
    }
    let reportView = gloGetReportView()
    return mainView === MAIN_VIEW_REPORT && reportView !== VIEW_MODE_DASHBOARD
}

export default class Home extends Component {
    constructor(props) {
        super(props);
        this.container = React.createRef()
        this.content = React.createRef()
        this.helpDesk = React.createRef()
        this.state = {
            isLoadingProjectList: this.props.isAuthenticated,
            userHasProjects: false,
            mainProjectView: MAIN_VIEW_STARTPAGE,
            reportViewMode: VIEW_MODE_DEFAULT,
            savedReportViewMode: VIEW_MODE_DEFAULT,
            refreshCounter: 0,
            showHelpDesk: HelpManager.isShowingHelpDesk(),
            searchId: undefined,
            givePermissionsReq: undefined,
            givenPermissionRole: "",
            customerAndProject: undefined,
            mayShowTable: true,
            mayShowTimeMatrix: true,
            activeProjectId: undefined,
            sidebarOpen: sideBarState.get().open || false,
            hideSideBar: false,
            hideTopPanel: false,
            editLinkForTable: undefined,        // editing link for dashboard or notification rule
            continueAfterEditLinkRule: undefined,  // for Project setting to continue edting rule
            isLoadingProject: false,
        }
        this.gotoPage = this.gotoPage.bind(this);
        this.switchToReportView = this.switchToReportView.bind(this);
        this.setMainProjectView = this.setMainProjectView.bind(this);
        this.setActiveProjectAfterNewProject = this.setActiveProjectAfterNewProject.bind(this);
        this.closeHelpDesk = this.closeHelpDesk.bind(this);
        this.termsAccepted = this.termsAccepted.bind(this)
        this.setUiFromLinkSettings = this.setUiFromLinkSettings.bind(this)
        this.openLink = this.openLink.bind(this)
        this.deferredSearchTimer = null
        // Save table settings while editing dashboard or rule filter to restore it
        this.savedTableSettings = undefined
    }

    async componentDidMount() {
        // prosLogX("Home:componentDidMount() authenticated:", this.props.isAuthenticated);
        if (!this.props.isAuthenticated) {
            prosLogX("WRN: Home:componentDidMount() user has not been authenticated");
            return
        }
        // when app is restarted or hadr refresh remembers still if on project settings page
        // but open project settings with main sub page
        prosConnect.deleteConfigStr(prosConnect.SAVED_SETTINGS_SUBVIEW)

        HelpManager.setHelpContext('main')
        prosPopupSetHost(this, "Home")
        projectLoader.subscribe_notifyProjectLoad("Home", (ev) => this.projectLoadListener(ev))

        let userHasProjects = await prosConnect.awaitStartProdect()
        if (userHasProjects) {
            this.setUiFromLinkSettings(prosConnect.getProjectLinkSettings())
            // admin user may get email with permission request link
            await this.checkIfStartedWithPermissionRequestLink()

            // check if started using link
            if (prosConnect.isLatestLinkErrorMissingPermission()) {
                this.requestPermissionsPopup()
            } else {
                let linkError = prosConnect.getLatestLinkError()
                if (linkError) {
                    prosNotificationShow(this, "Virhe linkissa: " + linkError, 'warning', true)
                }
            }
        }
        this.setState({
            isLoadingProjectList: false,
            userHasProjects: userHasProjects
        });
        let lastActiveMain = gloGetMainView()
        if ([MAIN_VIEW_MAIN_PRJ_SETTINGS, MAIN_VIEW_PROJECT_DASHBOARD].includes(lastActiveMain)) {
            const selectedMainPrj = restoreConfigStr(SAVED_SELECTED_MAIN_PROJECT)
            if (selectedMainPrj) {
                projectViewChanged(selectedMainPrj)
                let prj = await getMainProject(selectedMainPrj)
                this.setState({
                    customerAndProject: {
                        [ATTR_MAIN_PROJ_ID]: selectedMainPrj,
                        mainProjectName: prj ? prj.text : '',
                    }
                })
            }
            lastActiveMain = MAIN_VIEW_STARTPAGE
        }
        let lastActiveSub = gloGetReportView()
        this.setMainView(lastActiveMain, lastActiveSub)
    }

    componentWillUnmount() {
        prosLog("Home::componentWillUnmount() --");
        projectLoader.unsubscribe_notifyProjectLoad("Home")
        prosPopupSetHost(undefined)
    }

    setProjectAvailable(isProjectAvailable) {
        this.setState({isLoadingProject: false})
        if (isProjectAvailable) {
            let pid = prosConnect.getActiveProjectID()
            this.setState({activeProjectId: pid})
            this.updateServiceLevelPermittedDisplayMode()
            if (this.state.mainProjectView !== MAIN_VIEW_REPORT &&
                !prosConnect.hasPermissionTo('editProject')) {
                // Change main view when may not have permission to extra's
                //prosAppNotifWarnConfirm("Vaihdettu näyttö, sillä ei käyttöoikeuksia toimintoon valitulle osaprojektille")
                prosConnect.prosLogWrn("Changed view mode due to lag of permission")
                this.setState({continueAfterEditLinkRule: undefined})
                this.switchToReportView(0)
            }
        } else {
            this.setState({activeProjectId: undefined});
        }
    }

    projectLoadListener(ev) {
        // prosLogX("Home - projectLoadListener:", ev)
        switch (ev) {
            case projectLoader.SUB_PROJ_LOAD_EV_STARTED: {
                this.setState({isLoadingProject: true})
                break
            }
            case projectLoader.SUB_PROJ_LOAD_EV_INFO:
            {
                this.setState({isLoadingProject: false})
                this.setProjectAvailable(true)
                break
            }
            // case SUB_PROJ_LOAD_EV_PROGRESS: break;
            // case SUB_PROJ_LOAD_EV_COMPLETED: break;
            default: break
        }
    }

    updateServiceLevelPermittedDisplayMode() {
        let mayShowTable = featureEnabled(FEAT_SHOW_TABLE)
        let mayShowTimeMatrix = featureEnabled(FEAT_SHOW_TIME_MATRIX)
        if (!mayShowTable && !mayShowTimeMatrix && this.state.reportViewMode !== VIEW_MODE_LIST) {
            // Change to list mode for MyProdect that does not support table, calendar and dashboard
            this.setMainView(MAIN_VIEW_REPORT, VIEW_MODE_LIST)
        }
        if (mayShowTable !== this.state.mayShowTable ||
            mayShowTimeMatrix !== this.state.mayShowTimeMatrix) {
            this.setState({
                mayShowTable: mayShowTable,
                mayShowTimeMatrix: mayShowTimeMatrix,
            })
        }
    }

    async checkIfStartedWithPermissionRequestLink() {
        let permReq = await prosConnect.linkGrantPermission(false)
        if (permReq) {
            // Admin user - ui started from permission req link
            if (permReq.result === "OK" && permReq.for_user && permReq.link) {
                // Show popup dialog to grant permission
                this.showGivePermissionsPopup(permReq)
            } else if (permReq.errorCause === 'Already granted') {
                prosNotificationShow(this,"Linkin käyttöoikeus on jo annettu", 'warning', false)
                userHasAnsweredToGrantRequest()
            } else if (permReq.errorCause === 'No admin permission') {
                prosNotificationShow(this,"Ei käyttöoikeutta linkin pyynnölle", 'warning', false)
            } else {
                prosLogErr('Invalid perm req link', permReq)
                prosNotificationShow(this, "Käyttöoikeuspyynnössä virheellinen linkki", 'warning', false)
            }
        }
    }

    setUiFromLinkSettings(linkSettings) {
        if (!linkSettings) {
            return
        }
        prosConnect.prosLog("setUiFromLinkSettings() query string:", prosConnect.getSavedProsQueryString(),
            "pid:", linkSettings[ATTR_PROJECT_LINK])
        let activeProject = prosConnect.getActiveProject()
        if (!activeProject) {
            prosLogErr("No active project to use link settings")
            return
        }
        let projectId = activeProject.getPid()
        if (projectId !== linkSettings[ATTR_PROJECT_LINK]) {
            prosLogErr("Active project is not same as in saved link settings")
            return
        }
        // Check if is a project link used to open a dashboard
        if (isProjectDashboardLink()) {
            this.setMainView(MAIN_VIEW_REPORT, VIEW_MODE_DASHBOARD)
            return
        }
        // Select search or report
        let selectedReports = linkSettings[ATTR_SELECTED_REPORTS]
        let viewMode = linkSettings[ATTR_UI_VIEW_MODE]
        let isSearchMode = linkSettings[ATTR_UI_SEARCH]
        let uiSettings = linkSettings[ATTR_UI_SETTINGS]
        if (!selectedReports || !uiSettings) {
            prosLogErr("link - missing info")
            return
        }
        this.restoreMainViewSettingsFromLink(viewMode, isSearchMode, uiSettings)

        activeProject.unSelectReports()

        if (isSearchMode && selectedReports.length === 1) {
            let search = prosConnect.getObjById(selectedReports[0])
            if (search) {
                prosConnect.isReportToSelect(search, 'Home - project link search')
            } else {
            }
        } else {
            // Select also reports that has been created after link been created #20.17
            let addReportsCreatedAfterLink =
                activeProject.getReports(true)
                    .filter(projectReport =>
                        projectReport[ATTR_CREATED_MS_I] > linkSettings[ATTR_UPDATED_MS_I] &&
                        !selectedReports.find(linkReport => projectReport[ATTR_OBJ_ID] === linkReport[ATTR_OBJ_ID]))
                    .map(chosenRep => chosenRep[ATTR_OBJ_ID])
            let selectReports = selectedReports.concat(addReportsCreatedAfterLink)

            selectReports.forEach(reportId => {
                let report = prosConnect.getObjById(reportId)
                if (report) {
                    prosConnect.isReportToSelect(report, 'Home - project link report')
                } else {
                    prosLogErr('Report in link not loaded', reportId)
                }
            })
        }
        // View mode dependent settings
        if (viewMode && uiSettings.viewMode === VIEW_MODE_CALENDAR) {
            saveMatrixSettings(projectId, uiSettings)
            restoreMatrixUiSettings()
        } else if (viewMode && uiSettings.viewMode === VIEW_MODE_KANBAN) {
            saveMatrixSettingsKanban(projectId, uiSettings)
            restoreMatrixUiSettings()
        } else if (viewMode && uiSettings.viewMode === VIEW_MODE_TABLE) {
            setTableSettings(projectId, uiSettings)
        }
    }

    restoreMainViewSettingsFromLink(viewMode, isSearchMode, uiSettings) {
        // Ref ProjectReport 'savedUiMode'
        let mainViewSettings = {
            viewMode: viewMode,
            isSearchMode: isSearchMode,
        }
        if (uiSettings.hasOwnProperty('filterText')) {
            mainViewSettings.filterText = uiSettings.filterText
        }
        // Pass to ProjectReport
        setSavedViewMode(mainViewSettings, uiSettings)
        this.setMainView(MAIN_VIEW_REPORT, viewMode)
    }

    /**
     * Open link is used for opening
     *      - Prodect view by a www link
     *      - Opening bookmark
     *      - Opening table settings for dashboard
     *      - Opening table setting for notification rule
     * @param link              info about project, selected reports, view mode and view specific settings
     */
    openLink(link) {
        if (!prosConnect.isBookMarkValid(link)) {
            prosAppNotifWarn("Kirjanmerkki on virheellinen")
            return
        }
        if (!prosConnect.getActiveProject() ||
            link[ATTR_PROJECT_LINK] !== prosConnect.getActiveProject().getPid()) {
            // If would later intentionally use link from another project
            // need to load that project here before setting ui
            prosAppNotifNotice("Kirjanmerkki on eri projektille")
            return
        }
        this.setState({ activeProjectId: undefined})
        this.setUiFromLinkSettings(link)
        dumpTableFilter(prosConnect.getActiveProjectID(), "after setUiFromLinkSettings")
        this.refreshProjectView()
    }

    /**
     * Open table view showing meter or notification rule filter with data
     * @param projectId - meter sub project ID - expected to be same as current active project
     * @param linkUuid - link obj ID which is either a meter ID or notification rule ID
     * @param meterSettings - only for dashboard meter - used to choose table settings based on dashboard meter type /*
     */
    async editTableLinkSettings(projectId, linkUuid, meterSettings) {
        prosLog("Home:editTableLinkSettings() projectId:", projectId, "linkUuid:", linkUuid)
        if (projectId !== prosConnect.getActiveProjectID()) {
            alert ("Not supported yet to load a non active sub project link")
            prosLogErr("dashboard sub-project not same as active")
            return
        }
        let linkId = prosConnect.getActiveProject().getAttr(ATTR_CUSTOMER_GROUP) + ";" +  linkUuid
        let link = await prosConnect.awaitGetProjectLink(linkId, false)
        // Save current settings to restore current after editing filters
        this.savedTableSettings = restoreTableSettings(projectId, "editTableLinkSettings", true)
        if (link) {
            if (meterSettings) {
                prosLog("Opened meter data link:", linkId)
            } else {
                prosLog("Opened notification rule conditions link:", linkId)
            }
            this.openLink(link)
        } else {
            // prosLogX("No filter for link:", linkId)
            this.setMainView(MAIN_VIEW_REPORT, VIEW_MODE_TABLE)
            this.refreshProjectView()
        }
        this.setState({
            editLinkForTable: {
                linkUuid: linkUuid,
                projectId: projectId,
                meterSettings: meterSettings,
                link: link
            },
        })
        //scroll to page top if has scrolled in previous view
        window.scrollTo(0, 0)
    }

    restoreTableSettingsAfterEditFilter() {
        if (this.savedTableSettings) {
            setTableSettings(prosConnect.getActiveProjectID(), this.savedTableSettings)
        }
    }

    /**
     * This is called to close & open ProjectReport view especially for table view as React table component
     * need to be re-created to use new settings (which columns are shown and which order and width, sorting etc).
     * In addition to a link from URL, bookmark, dashboard and notification called also by
     * child ProjectReport to reload a table view with predefined quick filters.
     */
    refreshProjectView() {
        // to hide & show required for table to reload it with new settings from bookmark or link
        const REFRESH_TABLE_MS = 200;
        let hasProjectItemsLoaded = prosConnect.getActiveProject()?.hasItems
        this.setState({ activeProjectId: undefined})
        setTimeout(() => {
            if (hasProjectItemsLoaded) {
                // Project items already loaded - re-create table view
                prosLog("Home:refreshProjectView.timer set active project ID after a delay", prosConnect.getActiveProjectID())
                this.setState({ activeProjectId: prosConnect.getActiveProjectID()})
            } else {
                this.continueProjectSelected(prosConnect.getActiveProjectID())
            }
        }, REFRESH_TABLE_MS);
    }

    renderGivePermissionPopup() {
        if (!this.state.givePermissionsReq) {return null}
        let userId = this.state.givePermissionsReq.for_user
        let projectName = this.state.givePermissionsReq.link.proj_name
        return <>
            <section>
                <p>Käyttäjä <b>{userId}</b><br/>on pyytänyt käyttöoikeutta projektiin:</p>
                <p className={"prompt-highlight"}>{projectName}</p>
                <p>Valitse myönnettävä käyttöoikeus:</p>
                <div className="selection-group selection-group-radio">
                    {this.renderPermissionToProject(ROLE_READER)}
                    {this.renderPermissionToProject(ROLE_REPAIR)}
                    {this.renderPermissionToProject(ROLE_INSPECT)}
                </div>
            </section>
            <footer className={"popup-footer"}>
                <div className={"btn-set"}>
                    <CancelButton
                        label={"Älä myönnä"}
                        action={()=> this.hideGivePermissionsPopup()}
                    />
                    <ConfirmButton
                        label={"Myönnä käyttöoikeus"}
                        action={()=> this.givePermissionToProject(this.state.givenPermissionRole)}
                        disabled={this.state.givenPermissionRole === ""}
                    />
                </div>
            </footer>
        </>
    }

    showGivePermissionsPopup(permReq) {
        if (!permReq.for_user || !permReq.link || !permReq.link.proj_name) {return}
        this.setState({givePermissionsReq: permReq})
        prosLog("Show permission request", permReq)
        prosPopupOpenDynamic(this, 'Uusi käyttöoikeuspyyntö',
            () => this.renderGivePermissionPopup(),
            this.hideGivePermissionsPopup
        )
    }

    hideGivePermissionsPopup() {
        prosPopupClose()
        userHasAnsweredToGrantRequest()
    }

    async givePermissionToProject(role) {
        let userId = this.state.givePermissionsReq.for_user
        let result = await prosConnect.linkGrantPermission(true, role)
        if (result.result && result.result === 'OK') {
            prosNotificationShow(this, "Käyttöoikeudet annettu käyttäjälle " + userId)
            prosLog("granted access for", this.state.givePermissionsReq)
        } else {
            prosNotificationShow(this, "Virhe käyttöoikeuden antamisessa " +
                result.errorCause ? result.errorCause : '')
            prosLogErr("granting access:", result)
        }
        this.hideGivePermissionsPopup()
    }

    renderPermissionToProject(role) {
        return (
            <RadioButton
                checked={this.state.givenPermissionRole === role}
                text={prosConnect.getRoleForUi(role)}
                onChange={() => this.setState({givenPermissionRole: role})}
            />
        )
    }

    hideRequestPermissionsPopup() {
        prosConnect.cancelRequestPermissionToFailedLink()
        prosPopupClose()
    }

    async requestPermissionToProject() {
        prosPopupClose()
        let errorCause = await prosConnect.requestPermissionToFailedLink()
        if (errorCause) {
            prosNotificationShow(this, "Käyttöoikeuspyyntö epäonnistui: "
                + errorCause)
        } else {
            prosNotificationShow(this, "Käyttöoikeuspyyntö lähetetty")
        }
    }

    renderWarnNoProjects() {
        if (prosConnect.isSuperUserModeInUse()) {
            return (
            <div className="mini-page">
                <header className={"logo display-flex"}>
                    <img className="flex-center lander-logo" src={"./images/prodect-text.svg"} alt=""/>
                    <h1 className={"text-center"}>{"Käyttäjällä " + prosConnect.getCustomerTestEmail() + " ei ole käyttöoikeuksia."}</h1>
                </header>
                <footer className={"btn-set_center"}>
                    <BasicButton
                        label={"Palauta oma tunnus käyttöön"}
                        btnClass={"primary"}
                        action={() => {
                            setSuperUserMode(false, '')
                            this.reLoadProjects()
                        }}
                    />
                </footer>
            </div>
            )
        }
        return (
        <div className="mini-page">
            <header className={"logo display-flex"}>
                <img className="flex-center lander-logo" src={"./images/prodect-text.svg"} alt=""/>
                <h1 className={"text-center"}>Ei löytynyt käyttöoikeuksia projekteihin.</h1>
            </header>
            <section>
                <p>Olet kirjautunut tunnuksella:<br/><strong>{prosConnect.getUserEmail()}</strong></p>
                <p>Jos olet uusi käyttäjä ja haluat tilata projektin, valitse seuraava:</p>
                <div className={"btn-set_center"}>
                    <BasicButton
                        btnClass={"primary"}
                        label={"Tilaa uusi projekti"}
                        action={() => this.onCreateProjectClicked(undefined, MAIN_VIEW_CREATE_MAIN_PROJECT)}
                    />
                </div>
                <Spacer size={"lg"}/>
                <Spacer line={true} size={"lg"}/>
                <Spacer size={"lg"}/>
                <p>Jos sinulla pitäisi jo olla pääsy projekteihin tarkista että käyttöoikeus on annettu
                    oikealle sähköpostiosoitteelle.</p>
                <p>Jos olet jo käyttänyt Prodectia tällä tunnuksella ja sinulla on pääsy
                    Prodect projektiin paina alla olevaa painiketta ja kirjaudu uudelleen.</p>
            </section>
            <footer>
                <div className={"btn-set_center"}>
                    <BasicButton
                        btnClass={"2nd"}
                        label={"Kirjaudu ulos"}
                        action={this.props.handleLogout}
                    />
                </div>
            </footer>
        </div>
    )}

    requestPermissionsPopup() {
        if (prosConnect.requestPermissionToFailedLinkUsed()) { return null }
        let buttonText = permissionToLinkAlreadyRequested() ?
            "Pyydä käyttöoikeutta uudelleen" : "Pyydä käyttöoikeutta"
        let notifText = permissionToLinkAlreadyRequested() ?
            "Olet jo lähettänyt käyttöoikeuspyynnön." : "Pyydä käyttöoikeutta projektin hallitsijalta."
        prosPopupOpen(this,
            'Tarvitset käyttöoikeuden projektiin',
            <>
                <section>
                    <p className={"display-flex valign-center"}><i className={"ui-icon ui-icon ui-icon-outline-lock float-left"} /> {notifText}</p>
                </section>
                <footer className={"popup-footer"}>
                    <div className="btn-set">
                        <CancelButton
                            action={()=> this.hideRequestPermissionsPopup()}
                        />
                        <ConfirmButton
                            label={buttonText}
                            action={()=> this.requestPermissionToProject()}
                        />
                    </div>
                </footer>
            </>
        )
    }

    /**
     * View navigation request from sub-view to another view
     * @param page
     */
    gotoPage(page, param) {
        if (page === 'editSearch') {
            this.setMainView(MAIN_VIEW_SEARCH_SETTINGS)
            this.setState({
                searchId: param
            })
        } else {
            this.props.history.push(page)
        }
    }

    async reLoadProjects() {
        let userProjects = await prosConnect.awaitGetProjects(false);
        if (userProjects) {
            await prosConnect.awaitGetProjects(true)
        }
        this.setState({
            isLoadingProjectList: false,
            userHasProjects: userProjects
        })
    }

    switchToReportView = async (delayMsToRefreshProjects)=> {
        let pid = prosConnect.getActiveProjectID()
        if (pid) {
            this.setMainView(MAIN_VIEW_REPORT)
        } else {
            this.setMainView(MAIN_VIEW_STARTPAGE)
        }
        if (delayMsToRefreshProjects) {
            this.setState({
                isLoadingProjectList: true
            })
            setTimeout(() => this.reLoadProjects()
            , delayMsToRefreshProjects)
        }
    }

    switchToNewestProject = async () => {
        prosLog("Home:switchToNewestProject()")
        this.setState({
            isLoadingProjectList: true
        })
        await this.reLoadProjects()
        const latest_user_proj = prosConnect.getCurrentProjectList().reduce((latest, user_project) => {
            return user_project.created_ms > latest.created_ms ? user_project : latest;
        }, prosConnect.getCurrentProjectList()[0])
        // Switch to the latest project if it is less than 10 sec old
        if (latest_user_proj && latest_user_proj.created_ms > currentTimeMs() - 10 * 1000) {
            this.onProjectSelected(latest_user_proj.project_id, false)
        }
        this.setMainView(MAIN_VIEW_REPORT)
    }

    setActiveProjectAfterNewProject(projectId) {
        prosConnect.selectProjectById(projectId);
        let project = prosConnect.getActiveProject();
        this.setState({
            activeProject: project,
        })
       this.switchToReportView(0)
    }

    /**
     * Select view to continue after showing table filter for meter or notification rule
     */
    continueFromTableFilter() {
        if (this.state.editLinkForTable.meterSettings) {
            this.setMainView(MAIN_VIEW_REPORT, VIEW_MODE_DASHBOARD, false)
        } else {
            this.setMainView(MAIN_VIEW_NOTIFICATION_RULES, null, false)
        }
    }

    renderMainContent() {
        let isMakingNewProject = this.state.mainProjectView === MAIN_VIEW_CREATE_MAIN_PROJECT
        if (isMakingNewProject || this.state.mainProjectView === MAIN_VIEW_EDIT_CUSTOMER) {
            return <CreateMainProject
                switchToReportView={this.switchToReportView}
                isMakingNewProject={isMakingNewProject}
                customerAndProject={this.state.customerAndProject}
            />
        }
        if (this.state.mainProjectView === MAIN_VIEW_EDIT_PROJECT) {
            return <PermissionManagement
                closePage={this.switchToReportView}
                showSingleSubProject={false}
                subProjectId={this.state.editProjectAdminSubProjectId}
            />
        }
        if (!this.state.userHasProjects) {return}
        let activeProject = prosConnect.getActiveProject()
        const customerGroup = this.state.customerAndProject?.customerGroup
        if (this.state.mainProjectView === MAIN_VIEW_PROJECT_DASHBOARD && this.state.customerAndProject?.main_proj_id) {
            return <>
                {this.renderMainPrjTopPanel(this.state.customerAndProject?.mainProjectName, customerGroup, this.state.customerAndProject?.permSettings)}
                <ProjectDashboard
                    customerAndProject={this.state.customerAndProject}
                />
            </>
        }
        if (this.state.mainProjectView === MAIN_VIEW_MAIN_PRJ_SETTINGS && this.state.customerAndProject?.main_proj_id) {
            return <>
                {this.renderMainPrjTopPanel(this.state.customerAndProject?.mainProjectName, customerGroup, this.state.customerAndProject?.permSettings)}
                <MainProjectSettings
                    customerAndProject={this.state.customerAndProject}
                />
            </>
        }
        if (this.state.mainProjectView === MAIN_VIEW_REPORT) {
            if (activeProject) {
                if (this.state.activeProjectId) {
                    return <ProjectReports
                        activeProjectId={this.state.activeProjectId}
                        locationPictureMode={this.state.locationPictureMode}
                        gotoPage={this.gotoPage}
                        reportViewMode={this.state.reportViewMode}
                        openLink={this.openLink}
                        refreshProjectView={() => this.refreshProjectView()}
                        editTableLinkSettings={(projectId, linkUuid, meterSettings) =>
                            this.editTableLinkSettings(projectId, linkUuid, meterSettings)}
                        editLinkForTable={this.state.editLinkForTable}
                        continueFromTableFilter = {() => this.continueFromTableFilter()}
                    />
                } else {
                    return <LoadingAnimation size={"lg"} color={"var(--color-gray"}/>
                }
            }
        }
        if (this.state.mainProjectView ===  MAIN_VIEW_SETTINGS) {
            return <Settings
                closeView={this.switchToReportView}
                toggleShowingHelpDesk={() => this.toggleShowingHelpDesk()}
                showHelpDesk={this.state.showHelpDesk}
                handleLogout={this.props.handleLogout}
                setMainView={(view)=> this.setMainView(view)}
                projectSelected = {(project) => this.onProjectSelected(project.project_id)}
                switchToReportView={this.switchToReportView}
            />
        }
        if (this.state.mainProjectView ===  MAIN_VIEW_CUSTOMER_SETTINGS) {
            return <CustomerSettings
                closeView={this.switchToReportView}
                toggleShowingHelpDesk={() => this.toggleShowingHelpDesk()}
                showHelpDesk={this.state.showHelpDesk}
            />
        }
        // Views rendered after this are "closed temporally" until sub project project is loaded
        if (this.state.isLoadingProject && this.state.mainProjectView !== MAIN_VIEW_STARTPAGE) {
            return <LoadingAnimation size={"lg"} text={"Ladataan..."} />
        }
        if (this.state.mainProjectView === MAIN_VIEW_CREATE_NEW_SUBPROJECT) {
            return <CreateSubProject
                switchToReportView={this.switchToReportView}
                switchToNewestProject={this.switchToNewestProject}
                refProjectAttrs={this.state.refProjectAttrs}
                setActiveProject={this.setActiveProjectAfterNewProject}
                doneCallback={subprojectId => {
                    this.setMainView(MAIN_VIEW_REPORT, VIEW_MODE_LIST)
                    this.onProjectSelected(subprojectId, false)
                }}
            />
        }
        if (this.state.mainProjectView === MAIN_VIEW_SEARCH_SETTINGS) {
            return <SearchReportSettings
                searchId={this.state.searchId}
                switchToReportView={this.switchToReportView}
            />
        }
        if (this.state.mainProjectView === MAIN_VIEW_SUB_PROJECT_SETTINGS) {
            return <ProjectSettings
                closeView={(delayMsToRefreshProjects) => this.switchToReportView(delayMsToRefreshProjects)}
                activeProjectId={this.state.activeProjectId}
                reloadProject={pid => this.onProjectSelected(pid)}
            />
        }
        if (this.state.mainProjectView === MAIN_VIEW_NOTIFICATION_RULES) {
            return <NotificationRules
                projectName={this.state.projectName}
                mainProjectName={this.state.mainProjectName}
                editTableLinkSettings={ ((projectId, linkUuid, rule) => {
                    this.setState({
                        continueAfterEditLinkRule: rule
                    })
                    return this.editTableLinkSettings(projectId, linkUuid)
                }) }
                continueAfterEditLinkRule={this.state.continueAfterEditLinkRule}
                clearContinueAfterEditLinkRule={() => this.setState({continueAfterEditLinkRule: undefined})}
                setMainView={(view)=>this.setMainView(view)}
                toggleShowingHelpDesk={() => this.toggleShowingHelpDesk()}
            />
        }
        if (this.state.mainProjectView === MAIN_VIEW_SENT_REPORTS) {
            return <>
                <h1>Lähetetyt raportit</h1>
                <section className={"content"}>
                    <SharedReports
                        activeProject={prosConnect.getActiveProject()}
                    />
                </section>
            </>
        }
        if (this.state.mainProjectView === MAIN_VIEW_BOOK_MARKS) {
            return <>
                <h1>Kirjanmerkit</h1>
                <section className={"content content-bookmarks"}>
                    <Bookmarks
                        activeProject={prosConnect.getActiveProject()}
                        openLinkToBookmark={this.openLink}
                    />
                </section>
            </>
        }
        return <StartPage
            setMainView={view => this.setMainView(view)}
        />
    }

    // Used to clear state for view state interdependency - currently providing notifications table link
    // and continue editing notification rule - may add some other state cleanup
    cleanStateForViewChanges() {
        this.setState({
            editLinkForTable: undefined,
        })
    }

    setMainView(viewId, reportViewMode= null, rememberReportViewMode= true) {
        projectLoader.refreshUserIsActive()
        const currentView = this.state.mainProjectView
        prosLog("Home:setMainView() main:", currentView, "->", viewId,
            "reportViewMode:", reportViewMode)
        if (this.state.reportViewMode && rememberReportViewMode) {
            // when get back to normal view remember view mode
            this.setState({savedReportViewMode: this.state.reportViewMode})
        }
        if(USE_DEVELOPMENT_FEATURES) document.querySelector('html').classList.remove("dark-mode")
        if (viewId === MAIN_VIEW_REPORT) {
            let useReportViewMode = reportViewMode || this.state.savedReportViewMode
            saveConfigStr(SAVED_REPORT_VIEW, useReportViewMode)
            // switch back to saved view mode
            this.setState({reportViewMode: useReportViewMode})
            if(USE_DEVELOPMENT_FEATURES){
                if(useReportViewMode === VIEW_MODE_KANBAN){
                    document.querySelector('html').classList.add("dark-mode")
                }
            }
            prosLog("Home:setMainView() reportViewMode:", useReportViewMode)
        }
        this.setState({
            mainProjectView: viewId,
            hideSideBar: HIDE_SIDE_BAR_FOR_VIEWS.includes(viewId),
            hideTopPanel: HIDE_TOP_PANEL_FOR_VIEWS.includes(viewId)
        })
        if (DO_NOT_SAVE_VIEW.includes(viewId)) {
            // Do not memorize these views as these need some extra info as props - consider if add later
        } else {
            saveConfigStr(SAVED_MAIN_VIEW, viewId)
        }
        this.checkToContinueAfterEditingTableFilter()
        let activeProject = prosConnect.getActiveProject()
        if (activeProject) {
            let loadProjectItemsAfterViewChange =
                RELOAD_PROJECT_AFTER_VIEW.includes(currentView) ||
                (viewNeedsCompleteProject() && !activeProject.hasItems)
            if (loadProjectItemsAfterViewChange) {
                this.onProjectSelected(this.state.activeProjectId, false)
            } else if (viewId === MAIN_VIEW_REPORT && reportViewMode !== VIEW_MODE_DASHBOARD) {
                // Not loading all project items but switched to some other than dashboard view
                // -> start async refresh to get latest changes from server
                activeProject.awaitRefreshProjectObjectsFromAws()
            }
        }
    }

    /**
     * After editing table filter restore table active settings and clear "editing mode" i.e. editLinkForTable
     */
    checkToContinueAfterEditingTableFilter() {
        if (this.state.mainProjectView === MAIN_VIEW_REPORT && this.state.editLinkForTable) {
            this.restoreTableSettingsAfterEditFilter()
            this.setState({
                editLinkForTable: undefined,
            })
        }
    }

    setMainProjectView(state, refProject, customerAndProject) {
        prosLog("Home:setMainProjectView() from project ... menu", state, "customerAndProject:", customerAndProject)
        this.setState({
            refProjectAttrs: refProject,
            customerAndProject: customerAndProject
        })
        this.setMainView(state)
    }

    onCreateProjectClicked(refProject, projectCreateViewType) {
        if (prosConnect.getActiveProject() && refProject &&
            prosConnect.getActiveProject().getPid()  === refProject[ATTR_AWS_PROJECT_ID] &&
            this.state.mainProjectView === projectCreateViewType) {
            this.setMainProjectView(MAIN_VIEW_REPORT, null, null)
        } else {
            this.setMainProjectView(projectCreateViewType, refProject, null)
        }
    }

    /**
     * User selected different project
     * @param projectId         Project ID to be loaded
     */
    onProjectSelected(projectId) {
        prosLog('Home:onProjectSelected(), projectId:', projectId);
        // When editing project from ... menu and select subproject from side panel change to project report view
        if (this.state.mainProjectView === MAIN_VIEW_CREATE_MAIN_PROJECT ||
            this.state.mainProjectView === MAIN_VIEW_EDIT_CUSTOMER ||
            this.state.mainProjectView === MAIN_VIEW_EDIT_PROJECT ||
            this.state.mainProjectView === MAIN_VIEW_PROJECT_DASHBOARD ||
            this.state.mainProjectView === MAIN_VIEW_STARTPAGE ||
            this.state.mainProjectView === MAIN_VIEW_MAIN_PRJ_SETTINGS) {
            this.setMainView(MAIN_VIEW_REPORT)
        }
        resetToNormalReportMode()
        this.continueProjectSelected(projectId)
        projectViewChanged()
    }

    // Used to start loading subproject data incrementally.
    continueProjectSelected(projectId) {
        prosLog('Home:continueProjectSelected(), projectId:', projectId);
        prosLogClearDt()
        this.cleanStateForViewChanges()
        this.setProjectAvailable(false)
        let project = prosConnect.selectProjectById(projectId);
        if (project) {
            projectLoader.awaitLoadProjectObjects(projectId, 'Home')
        } else {
            this.setState({isLoadingProject: false})
            this.setMainView(MAIN_VIEW_STARTPAGE)
            prosLogErr("Project not found to load:", projectId)
        }
    }

    closeHelpDesk() {
        this.setState({
            showHelpDesk: false,
        })
        HelpManager.setShowingHelpDesk(false)
        localStorage.setItem("showingHelpDesk", "false")
    }

    renderHelpDesk() {
        if (!this.state.showHelpDesk) {
            return
        }
        return <div ref={this.helpDesk} className={"helpdesk dark-mode"}>
            <HelpDesk
                closeHelpDesk={() => this.closeHelpDesk()}
                host="Home"
            />
        </div>
    }

    resetView(){
        sideBarState.set(sideBarState.get().locked, sideBarState.get().locked)
        this.closeHelpDesk()
        resetViewToDefault()
        this.setMainView(MAIN_VIEW_STARTPAGE)
        this.setState({
            hideTopPanel: true,
            sidebarOpen: sideBarState.get().locked,
        })
        this.reLoadProjects()
    }

    toggleShowingHelpDesk(){
        HelpManager.setShowingHelpDesk(!this.state.showHelpDesk)
        this.setState({
            showHelpDesk : !this.state.showHelpDesk
        })
    }

    renderSidebar() {
        if (this.state.hideSideBar) {
            return null
        }
        if (!this.props.isAuthenticated) {
            handleSessionException('home-1');
            return <h2>Kirjaudu sovellukseen</h2>
        }
        return <ProsSidebar
            resetView={()=> this.resetView()}
            toggleShowingHelpDesk={() => this.toggleShowingHelpDesk()}
            showHelpDesk={this.state.showHelpDesk}
            handleLogout={this.props.handleLogout}
            setMainView={(view)=> this.setMainView(view)}
            setMainProjectView={this.setMainProjectView}
            projectSelected={projectId => this.onProjectSelected(projectId)}
            switchToReportView={this.switchToReportView}
            currentProjectView={this.state.mainProjectView}
            createProjectClicked={(refProject, projectCreateViewType) =>
                this.onCreateProjectClicked(refProject, projectCreateViewType)}
            //launchEditProjectUsers={project_id => this.launchEditProjectUsers(project_id)}
            openMainProjectPage={(mainProject, view, permSettings)=>{
                this.changeMainProjectPage(mainProject, view, permSettings)
            }}
            mainProjectId={this.state.customerAndProject?.main_proj_id}
            isSidebarOpen={this.state.sidebarOpen}
        />
    }

    changeMainProjectPage(mainProject, view, permSettings= false){
        saveConfigStr(SAVED_SELECTED_MAIN_PROJECT, mainProject.mainProjectId)
        projectViewChanged(mainProject.mainProjectId)
        this.setMainProjectView(view, null, {
            customerGroup: mainProject.customerGroup,
            mainProjectName: mainProject.name,
            //mainProject: mainProject,
            permSettings: permSettings,
            [ATTR_MAIN_PROJ_ID]: mainProject.mainProjectId
        })
    }

    changeProjectView =(mode)=>{
        // User pressed List / Table / Calendar / Kanban view mode selection
        prosConnect.deleteConfigStr(prosConnect.SAVED_SETTINGS_SUBVIEW)
        this.cleanStateForViewChanges()
        this.setMainView(MAIN_VIEW_REPORT, mode)
    }

    renderModeToggleButton(mayShow, mode, mainPrjView = undefined) {
        if (!mayShow) {
            return null
        }
        let isSelected = this.state.reportViewMode && this.state.reportViewMode === mode
            && (this.state.mainProjectView === 'reportView' || !this.state.mainProjectView)
        if (mainPrjView) {
            isSelected = !!(this.state.mainProjectView && this.state.mainProjectView === mode)
        }
        return <BasicButton
                icon={VIEW_MODES[mode].icon}
                iconColor={isSelected ? "light" : null}
                action={()=> {
                    if (mainPrjView) {
                        this.cleanStateForViewChanges()
                        this.setMainView(mode)
                    } else {
                        this.changeProjectView(mode)
                    }
                }}
                selected={isSelected}
            >
            <div className={"text-center text-xs"}>{VIEW_MODES[mode].text}</div>
        </BasicButton>
    }

    renderSelectedProjectSettingsMenu() {
        let activeProject = prosConnect.getActiveProject()
        const outputList = []
        const isReportView = this.state.mainProjectView === 'reportView'
        const changeView = view => {
            this.setMainView(view)
            sideBarState.set(false, false)
        }

        if(this.state.mayShowTable) outputList.push({
            text: 'Tilanne',
            icon: 'gauge',
            selected: isReportView && this.state.reportViewMode === VIEW_MODE_DASHBOARD,
            action: ()=> {
                this.changeProjectView(VIEW_MODE_DASHBOARD)
            },
            className: "dom-hide_lg"
        })
        outputList.push({
            text: 'Lista',
            icon: 'list',
            selected: isReportView && this.state.reportViewMode === VIEW_MODE_LIST,
            action: ()=> {
                this.changeProjectView(VIEW_MODE_LIST)
            },
            className: "dom-hide_lg"
        })
        if(this.state.mayShowTable) outputList.push({
            text: 'Taulukko',
            icon: 'table',
            selected: isReportView && this.state.reportViewMode === VIEW_MODE_TABLE,
            action: ()=> {
                this.changeProjectView(VIEW_MODE_TABLE)
            },
            className: "dom-hide dom-show_md dom-hide_lg"
        })
        if(this.state.mayShowTimeMatrix) {
            outputList.push(
                {
                    text: 'Kalenteri',
                    icon: 'calendar',
                    selected: isReportView && this.state.reportViewMode === VIEW_MODE_CALENDAR,
                    action: ()=> {
                        this.changeProjectView(VIEW_MODE_CALENDAR)
                    },
                    className: "dom-hide dom-show_md dom-hide_lg"
                },
                {
                    text: 'Kanban',
                    icon: 'kanban',
                    selected: isReportView && this.state.reportViewMode === VIEW_MODE_KANBAN,
                    action: ()=> {
                        this.changeProjectView(VIEW_MODE_KANBAN)
                    },
                    className: "dom-hide dom-show_md dom-hide_lg"
                })
        }
        let menuList
        let hasPermissionToEditProject = activeProject && prosConnect.hasPermissionTo("editProjectSettings")
        let hasPermissionToAddContent = activeProject && prosConnect.hasPermissionTo("addContent")
        let noPermissionsForExtras = !hasPermissionToEditProject && !hasPermissionToAddContent
        if (noPermissionsForExtras) {
            menuList = [{
                text: 'Ei oikeuksia',
                icon: 'outline-lock',
                action: ()=>{return false},
                className: "dom-hide dom-show_lg"
            }]
        } else {
            // set first menu items that are visible for restricted permissions user
            menuList = [
                {
                    text: 'Ilmoitukset',
                    icon: 'bell',
                    selected: this.state.mainProjectView === MAIN_VIEW_NOTIFICATION_RULES,
                    action: ()=> {
                        changeView(MAIN_VIEW_NOTIFICATION_RULES)
                    }
                },
                {
                    text: 'Kirjanmerkit',
                    icon: 'bookmark',
                    selected: this.state.mainProjectView === MAIN_VIEW_BOOK_MARKS,
                    action: ()=> {
                        changeView(MAIN_VIEW_BOOK_MARKS)
                    }
                }
            ]
            if (hasPermissionToEditProject) {
                // menu items restricted for admin and inspect permissions
                menuList.unshift({
                    text: 'Asetukset',
                    icon: 'folder-gear',
                    selected: this.state.mainProjectView === MAIN_VIEW_SUB_PROJECT_SETTINGS,
                    action: () => {
                        changeView(MAIN_VIEW_SUB_PROJECT_SETTINGS)
                    }
                })
                menuList.push({
                    text: 'Lähetetyt raportit',
                    icon: 'send',
                    selected: this.state.mainProjectView === MAIN_VIEW_SENT_REPORTS,
                    action: () => {
                        changeView(MAIN_VIEW_SENT_REPORTS)
                    }
                })
            }
            if (activeProject.isMyProdectProject()) {
                menuList = menuList.filter(menuItem => menuItem.icon !== 'bookmark')
            }
        }
        if(outputList.length < 1 && menuList.length < 1) return null
        return <DropdownMenu
            values={[...outputList, ...menuList]}
            text={false}
            icon={"ellipsis-v"}
            hideArrow
            btnClass={"3rd"}
            btnType={noPermissionsForExtras ? "locked" : null}
            active={this.state.mainProjectView === MAIN_VIEW_BOOK_MARKS
                || this.state.mainProjectView === MAIN_VIEW_SENT_REPORTS
                || this.state.mainProjectView === MAIN_VIEW_SUB_PROJECT_SETTINGS
                || this.state.mainProjectView === MAIN_VIEW_NOTIFICATION_RULES
                || isSmallDevice()
            }
            className={"ui-dropdown-align-right"}
        />
    }

    renderMainPrjTopPanel(mainProjectName, customerGroup, permSettings) {
        return <ProjectHeader mainProjectView mainProjectName={mainProjectName}>
            <nav className={"nav-page-header"}>
                <div className={"btn-set"}>
                    {this.renderModeToggleButton(true, MAIN_VIEW_PROJECT_DASHBOARD, true)}
                    {permSettings ? this.renderModeToggleButton(true, MAIN_VIEW_MAIN_PRJ_SETTINGS, true) : null}
                </div>
            </nav>
        </ProjectHeader>
    }

    renderTopPanel() {
        if (this.state.hideTopPanel) {
            return null
        }
        return <ProjectHeader>
            <nav className={"nav-page-header"}>
                <div className={"btn-set"}>
                    {this.renderModeToggleButton(this.state.mayShowTable, VIEW_MODE_DASHBOARD)}
                    {this.renderModeToggleButton(true, VIEW_MODE_LIST)}
                    {this.renderModeToggleButton(this.state.mayShowTable, VIEW_MODE_TABLE)}
                    {this.renderModeToggleButton(this.state.mayShowTimeMatrix, VIEW_MODE_CALENDAR)}
                    {this.renderModeToggleButton(this.state.mayShowTimeMatrix, VIEW_MODE_KANBAN)}
                    {this.renderSelectedProjectSettingsMenu()}
                </div>
            </nav>
        </ProjectHeader>
    }

    renderProjectViews() {
        return <div
                ref={this.container}
                className={"app" + (this.state.showHelpDesk ? " helpdesk-visible " : "")}
            >
            {this.renderSidebar()}
            <div ref={this.content} className={"main-container " + this.state.mainProjectView?.toLowerCase()}>
                <span id={"pageTop"} />
                {this.renderTopPanel()}
                {this.renderMainContent()}
                <span id={"pageBottom"} />
            </div>
            {this.renderHelpDesk()}
        </div>
    }

    renderReasonForSignout() {
        const signoutError = prosConnect.getLatestSignoutError()
        if (!signoutError) {
            return null
        }
        return <div className="text-center">
            <h3>Syy kirjautumiseen:</h3>
            <p>{signoutError}</p>
        </div>
    }

    renderLander() {
        return <>
            <div className="mini-page">
                <header className={"logo display-flex"}>
                    <img className="flex-center lander-logo" src={"./images/prodect-text.svg"} alt=""/>
                    <h1 className={"text-center"}>Projektitiimin paras kaveri</h1>
                </header>
                <section>
                    <div className="btn-set_center">
                        <Link to="/authLogin" className="btn btn-2nd">
                            <span>Kirjaudu sisään</span>
                        </Link>
                        <Link to="/authSignup" className="btn btn-primary">
                            <span>Rekisteröidy</span>
                        </Link>
                    </div>
                    <Spacer size={"lg"}/>
                    <div className={"text-center"}>
                        <p>
                            <Link to="/authForgotPwd">
                                Unohditko salasanan?
                            </Link>
                        </p>
                    </div>
                    <Spacer />
                    <div className={"text-center"}>
                        <p>Sain jo koodin sähköpostiin - <Link to="/authContinueSignonWithCode">
                            jatka vahvistamaan sähköpostiosoite
                            </Link>
                        </p>
                    </div>
                    {this.renderReasonForSignout()}
                </section>
            </div>
            <footer>
                <h2>Lataa sovellus</h2>
                <a href="https://play.google.com/store/apps/details?id=com.nivalajt.pros.sanelin"
                   target="_blank" rel="noopener noreferrer"
                ><img src="https://prodect.com/wp-content/uploads/2021/11/prodect-google-play.png"
                      width="135" height="40" alt=""/>
                </a>
                <a href="https://apps.apple.com/us/app/prodect/id1476204478"
                   target="_blank" rel="noopener noreferrer"
                ><img
                    src="https://prodect.com/wp-content/uploads/2021/11/prodect-appstore.png"
                    width="143" height="40" alt=""/>
                </a>
            </footer>
        </>
    }

    async termsAccepted(accepted) {
        if (accepted) {
            await prosConnect.awaitUserAcceptedTerms()
        } else {
            appProdectLogout("Käyttöehtoja ei ole hyväksytty")
        }
        // UI to be rendered after terms been accepted
        this.setState({
            refreshCounter: this.state.refreshCounter + 1
        })
    }

    renderMain() {
        // Sequence steps when app is started
        if (!this.props.isAuthenticated) {
            // #1 - user not authenticated
            return this.renderLander()
        }
        if (!prosConnect.hasProdectStarted()) {
            // console.log("Home -- waiting for prodect to be started")
            return <LoadingAnimation size={"lg"} text={"Hetkinen..."} />
        }
        if (this.state.isLoadingProjectList){
            // #2 - show loading... until connected to server and fetched user's project list
            // ref componenDidMount calling awaitStartProdect
            // console.log("Home -- waiting to load project list")
            return <LoadingAnimation size={"lg"} text={"Ladataan projekteja..."} />
        }
        if (!prosConnect.hasUserAcceptedTerms() && this.state.mainProjectView !== MAIN_VIEW_CREATE_MAIN_PROJECT) {
            // #3 - request user to accept terms..
            return <AcceptTerms termsAccepted={this.termsAccepted}/>
        }
        if (!this.state.userHasProjects && this.state.mainProjectView !== MAIN_VIEW_CREATE_MAIN_PROJECT) {
            // #4 - user has no projects - ask to create new project
            return this.renderWarnNoProjects()
        }
        // #5 - normal project list & main view
        return this.renderProjectViews()
    }

    render() {
        require("./assets/scss/Home.scss")
        require("./assets/scss/ProjectReports.scss")
        if (!prosConnect.getUserEmail() && !triedLogoutRecovery) {
            triedLogoutRecovery = true
            prosLogX("Kirjaudu uudelleen")
            appProdectLogout()
        }
        return <>
            {this.renderMain()}
            {prosPopupRender(this, 'Home')}
        </>
    }
}
